import Lens from '../../../shared/Icons/Lens';
import AsyncButton from '../../../shared/Loading/AsyncButton';

const Toolbar = ({
  query,
  setQuery,
  canSeeAdmin,
  findRole,
  setFindRole,
  roles,
  isCreator,
  isEliminator,
  selectedCount,
  onAddUser,
  onDeleteSelected,
}) => {
  return (
    <div className="p-4  flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between border-b">
      <div className="relative w-full sm:w-80">
        <Lens/>
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Buscar por nombre o correo"
          className="w-full border border-gray-300 pl-9 pr-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 rounded"
        />
      </div>
      {canSeeAdmin && (
        <div className="relative w-full sm:w-40 md:mb-6">
          <label className="block text-[11px] text-gray-500 mb-1">Buscar por rol</label>
          <select
            value={findRole ?? 'Todos'}
            onChange={(e) => setFindRole(e.target.value)}
            className="w-full border border-gray-300 rounded px-3 py-2 text-sm bg-white"
          >
            <option value="Todos">Todos</option>
            {roles.map((opt) => (
              <option key={opt.Id} value={opt.Name}>
                {opt.Name}
              </option>
            ))}
          </select>
        </div>
      )}
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3">
        {isCreator && (
          <AsyncButton
            onClick={onAddUser}
            className="w-full sm:w-auto bg-personalized text-white px-4 py-2 text-sm border border-transparent
              rounded hover:bg-white hover:text-personalized hover:border-personalized whitespace-nowrap"
          >
            Agregar usuario
          </AsyncButton>
        )}
        {isEliminator && (
          <AsyncButton
            onClick={onDeleteSelected}
            disabled={selectedCount === 0}
            className={`inline-flex items-center justify-center whitespace-nowrap shrink-0 px-4 py-2 text-sm border rounded ${
              selectedCount === 0
                ? 'bg-red-300 cursor-not-allowed text-white border-transparent'
                : 'bg-red-500 text-white border-transparent hover:bg-white hover:text-red-500 hover:border-red-500'
            }`}
            title={selectedCount === 0 ? 'Selecciona al menos un usuario' : 'Eliminar seleccionados'}
          >
            Eliminar {selectedCount ? `(${selectedCount})` : ''}
          </AsyncButton>
        )}
      </div>
    </div>
  );
};

export default Toolbar;
